import React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {RootMachineContext} from '../../machines/rootMachine';
import {selectMeetingDateTime} from '../../selectors/select-meeting-date-time';

import {
  BodySmall,
  BodySmallBold,
} from '@spaced-out/ui-design-system/lib/components/Text';

import css from './meeting-date-time-info.css';


export const MeetingDateTimeInfo = () => {
  const {t, language} = useLabelTranslation();
  const meetingDateTime = RootMachineContext.useSelector((state) =>
    selectMeetingDateTime(state, language),
  );

  return (
    <div className={css.meetingDateTimeInfo}>
      <BodySmall color="secondary">
        {t('Meeting_scheduled_for', 'Meeting scheduled for')}
      </BodySmall>
      {/* Note: translation already handled */}
      {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
      <BodySmallBold>{meetingDateTime}</BodySmallBold>
    </div>
  );
};
